// extracted by mini-css-extract-plugin
export default {"root":"ConnectPolicy_root__3AxS6","message":"ConnectPolicy_message__XveUa","link":"ConnectPolicy_link__uR2I8"};